export default __webpack_public_path__ + "static/media/plus-square-o.0c0fd07c.svg";